import React from 'react';
import { Modal, Form, Input } from 'antd';
import { useLeaveStore } from '../../../../config/stores';

const { TextArea } = Input;

const LeaveApprovalModal = ({ 
  visible, 
  onCancel, 
  onSubmit, 
  loading, 
  action,
}) => {
  const [form] = Form.useForm();
  
  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      onSubmit(values);
      form.resetFields();
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  const labels = {
    check: { verb: 'Check', noun: 'check' },
    approve: { verb: 'Approve', noun: 'approval' },
    reject: { verb: 'Reject', noun: 'rejection' },
  };
  const { verb, noun } = labels[action] || labels.approve;
  const title = `${verb} Leave Application`;

  return (
    <Modal
      title={title}
      open={visible}
      onCancel={onCancel}
      onOk={handleSubmit}
      okText={verb}
      confirmLoading={loading}
      okButtonProps={{
        danger: action === 'reject',
      }}
    >
      <Form
        form={form}
        layout="vertical"
      >
        <Form.Item
          name="comment"
          label="Comment"
          rules={[
            {
              required: true,
              message: `Please provide a ${noun} comment`,
            },
          ]}
        >
          <TextArea
            rows={4}
            placeholder={`Enter your ${noun} comment`}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default LeaveApprovalModal; 